<template>
  <CommonEmployeeDetailsModal
    :title="
      $t('EMPLOYEESGENERAL.MESSAGE.MANAGE', {
        employee: this.selectedEmployee.name,
      })
    "
  >
    <div class="d-flex justify-content-center">
      <b-avatar
        :src="avatarUrl"
        variant="light"
        size="15em"
        class="mx-auto mb-5"
      ></b-avatar>
    </div>

    <CommonSchoolImageUpload
      @uploadClicked="handleUpload"
      @cancel-clicked="changePhase"
      @webcam-clicked="changePhase"
      :phase="phase"
    ></CommonSchoolImageUpload>

    <CommonEmployeeDetailForm
      :is-busy="isBusy"
      @submit="handleSubmit"
      @check-code="checkCode"
      :form-set="selectedEmployee"
      :code-exist-status="codeStatus"
    ></CommonEmployeeDetailForm>
  </CommonEmployeeDetailsModal>
</template>

<script>
import CommonEmployeeDetailsModal from "@/modules/school/components/shared/employee/modal/CommonEmployeeDetailsModal";
import CommonEmployeeDetailForm from "@/modules/school/components/shared/employee/form/CommonEmployeeDetailForm";
import CommonSchoolImageUpload from "@/modules/school/components/shared/utility/CommonSchoolImageUpload";

export default {
  name: "TeacherPageDetailsModal",
  components: {
    CommonSchoolImageUpload,
    CommonEmployeeDetailForm,
    CommonEmployeeDetailsModal,
  },
  props: {
    title: {
      String,
    },
    selectedEmployee: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isBusy: false,
      phase: "default",
      codeStatus: false,
    };
  },

  mounted() {
    console.log("Mounted", this.selectedEmployee);
  },

  methods: {
    /**
     * Handle Teacher general details form submission
     *
     * @param form
     */
    handleSubmit(form) {
      console.log(form);

      const payload = {
        ...form,
        id: this.selectedEmployee.id,
      };

      this.isBusy = true;
      this.$store
        .dispatch("updateTeacherGeneralDetails", payload)
        .then((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk("Success!!");
        })
        .finally(() => {
          this.isBusy = false;
          this.$emit("detailsUpdated");
        });
    },

    /**
     * Handle image upload button event
     *
     * @param image
     */
    handleUpload(image) {
      console.log("Teacher image: ", image);
      this.$store
        .dispatch("uploadTeacherImage", {
          image: image,
          id: this.selectedEmployee.id,
        })
        .then((res) => {
          console.log(res.data);
          this.$bvModal.msgBoxOk(
            "Successfully uploaded image. Image can now be used for facial device recognition.",
            {
              title: "Image uploaded",
              centered: true,
            }
          );
          this.selectedEmployee.image_url = res.data.url;
        })
        .finally(() => {
          this.imageBusy = !this.imageBusy;
          this.phase = "default";
          this.$emit("detailsUpdated");
        });
    },

    /**
     *
     * @param code
     */
    checkCode(code) {
      console.log("Watching: ", code);

      if (code) {
        const payload = {
          code: code.code,
          id: code.id,
        };

        console.log("Kat Sini");
        this.$store
          .dispatch("checkExistingTeacherCode", payload)
          .then((response) => {
            console.log(response);
            this.codeStatus = response.data.status === "true";
            if (response.data.status === "true") {
              console.log("Data Exist");
            }
            console.log("New Code Status: ", this.codeStatus);
          });
      }
    },

    changePhase() {
      this.phase = this.phase === "WEBCAM_PHASE" ? "default" : "WEBCAM_PHASE";
    },
  },

  computed: {
    avatarUrl() {
      return this.selectedEmployee.image_url;
    },
  },
};
</script>

<style scoped></style>
